import { getDomain } from './get-domain';
function getImageServer(){
	let domain = document.location.hostname.includes("localhost") ? 'staging.' : getDomain();
	if(document.location.hostname.includes("localhost") && document.location.port=="3000"){
		return 'localhost.medscape.com:3000';
	}
	return `img.${domain}medscapestatic.com`;
}

export { getImageServer };